import React from "react";
import { isChunkLoadError, triggerChunkReloadOnce } from "../utils/lazyWithRecovery";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (triggerChunkReloadOnce(error, "error-boundary")) {
      return;
    }

    // Optionally log to an error reporting service
    console.error("ErrorBoundary caught an error:", error, info);
  }

  handleRetry = () => {
    if (isChunkLoadError(this.state.error)) {
      window.location.reload();
      return;
    }

    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[40vh] flex items-center justify-center p-6">
          <div className="max-w-lg w-full bg-white dark:bg-navy-800 border border-gray-200 dark:border-navy-600 rounded-lg p-6 text-center shadow">
            <h2 className="text-xl font-semibold text-red-600 mb-2">Something went wrong</h2>
            <p className="text-gray-700 dark:text-navy-200 mb-4">
              An unexpected error occurred. You can try again, or refresh the page.
            </p>
            <button
              onClick={this.handleRetry}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-navy-900"
            >
              Try again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
